var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "44px",
    height: "44px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22.5,
    width: 10,
    height: 55,
    fill: "#fbc926"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.9615384615384615s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "-5;22.5;22.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.19230769230769232s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.9615384615384615s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "110;55;55",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.19230769230769232s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 22.5,
    width: 10,
    height: 55,
    fill: "#b2b2b2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.9615384615384615s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "1.875;22.5;22.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.09615384615384616s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.9615384615384615s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "96.25;55;55",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.09615384615384616s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 22.5,
    width: 10,
    height: 55,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.9615384615384615s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "1.875;22.5;22.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.9615384615384615s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "96.25;55;55",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimated);
export default __webpack_public_path__ + "static/media/animated.6a774a7f153221a35aaff35995655389.svg";
export { ForwardRef as ReactComponent };